import { useTheme } from "../context/ThemeContext";
import { Briefcase, Sparkles } from "lucide-react";

export function ModeToggle({ compact = false }) {
  const { mode, isNegocio, toggle } = useTheme();

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="mode-toggle"
      role="switch"
      aria-checked={isNegocio}
      aria-label={`Cambiar a ${isNegocio ? "Modo General" : "Modo Negocio"}`}
      className={
        "relative flex items-center gap-2 rounded-full border transition-colors duration-300 " +
        (compact ? "px-1 py-1" : "px-1.5 py-1.5") +
        " bg-black/40 border-white/10 hover:border-white/20"
      }
    >
      <span
        className={
          "flex items-center gap-1.5 rounded-full transition-colors duration-300 " +
          (compact ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs") +
          " font-display font-semibold uppercase tracking-wider " +
          (!isNegocio ? "text-[#0b1220]" : "text-slate-300")
        }
        style={!isNegocio ? { background: "#06B6D4" } : undefined}
      >
        <Sparkles size={compact ? 12 : 14} strokeWidth={2.4} />
        General
      </span>
      <span
        className={
          "flex items-center gap-1.5 rounded-full transition-colors duration-300 " +
          (compact ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs") +
          " font-display font-semibold uppercase tracking-wider " +
          (isNegocio ? "text-[#1a0509]" : "text-slate-300")
        }
        style={isNegocio ? { background: "#E11D48" } : undefined}
      >
        <Briefcase size={compact ? 12 : 14} strokeWidth={2.4} />
        Negocio
      </span>
      <span className="sr-only" data-testid="mode-state">{mode}</span>
    </button>
  );
}
